import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchYojanaCategories, deleteYojanaCategory } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'categoryId', label: 'ID', minWidth: 50 },
  { id: 'categoryName', label: 'Category Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 300 },
];

const normalizeCategory = (category) => {
  const categoryId =
    category?.categoryId ??
    category?.yojanaCategoryId ??
    category?.id;

  const categoryName =
    category?.categoryName ??
    category?.yojanaCategoryName ??
    category?.name ??
    '';

  return {
    ...category,
    id: categoryId,
    categoryId,
    categoryName,
  };
};

const YojanaCategoryList = ({ onEdit, searchQuery = '' }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadCategories = async () => {
      setLoading(true);
      try {
        const response = await fetchYojanaCategories();
        if (cancelled) return;
        const data = Array.isArray(response?.data) ? response.data : [];
        setCategories(data.map(normalizeCategory));
        setError(null);
      } catch (err) {
        console.error('Error fetching yojana categories:', err);
        if (!cancelled) {
          setError('Failed to load yojana categories. Please try again later.');
          setCategories([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadCategories();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (category) => {
    try {
      const categoryId =
        category?.categoryId ??
        category?.yojanaCategoryId ??
        category?.id;

      await deleteYojanaCategory(categoryId, {
        previousData: category,
        identifier: category?.categoryName
      });
      setRefreshTrigger((prev) => prev + 1);
    } catch (err) {
      console.error('Error deleting yojana category:', err);
      alert('Failed to delete yojana category. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Yojana Categories
      </Typography>

      <MasterDataTable
        persistKey="yojanaCategory"
        data={categories}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={(category) => onEdit(normalizeCategory(category))}
        onDelete={handleDelete}
        emptyMessage="No yojana categories found. Add your first yojana category!"
      />

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default YojanaCategoryList;

